export const environment = {
  	production: true,
	apiUrl: 'https://test-api.medberos.com/api/',
  	userInfo_LocalStoreKey: 'userData',
};

export const messagesSpanish = {
  //Error 500
  No_control_error:"Error no controlado",

  //Error 400
  Bad_request:"Error en el envio de body request",

  //Error 204
  No_content: "No hay contenido en la solicitud",

  //Mensaje cancelar
  Cancel_Process:"Se cancelo el proceso",

  //Paciente 
  Patient_Already_Exist:"Este usuario ya existe",
  Patient_Registration_Bad_Request:"No se pudo crear el paciente",
  Patient_Registered:"Paciente afiliado correctamente",

  //Login
  Email_Not_Confirmed:"Su e-mail no esta confirmado",
  Not_Authorized:"Credenciales incorrectas",
  Invalid_email_or_password:"Credenciales incorrectas",
  Invalid_PhoneNumber: "Su número de teléfono es inválido",

  //Validar SMS
  Incorrect_code: "Código SMS no válido",
  Valid_code_401: "El usuario no esta autorizado",
  Valid_code: "Código validado correctamente",
  Code_Expired: "El código ha expirado. Solicite uno nuevo.",
  Too_Many_Attempts: "Demasiados intentos fallidos. Solicite un nuevo código.",
  Sms_Cooldown: "Debe esperar 60 segundos antes de solicitar otro código.",
  Sms_Sent: "Se ha enviado un nuevo código a su teléfono.",
  Code_Required: "Debe ingresar el código de verificación.",
  Phone_Not_Set: "No tiene un número de teléfono registrado.",

  //Reporte Atencion
  The_note_attention_not_found: "La atencion no fue encontrada",
  The_evolution_note_not_found: "La evolucion no fue encontrada",
  The_prescription_not_found: "La receta no fue encontrada",
  The_interconsultation_not_found: "La interconsulta no fue encontrada",
  The_exam_not_found: "El examen no fue encontrado",
  The_notes_not_found: "Las notas no fueron encontradas",

  //Acciones para la Atencion
  Note_closed_successfully: "La atencion fue cerrar correctamente",

  //Usuario
  Password_change_success: "Password cambiado correctamente",
  Password_update_wrong: "Error al cambiar el password",
  User_Not_Found: "Usuario no encontrado",

  //Note
  Note_Saved: "Atención guardada satisfactoriamente",
  Triage_Saved: "Triaje grabado satisfactoriamente",
  Prescription_Saved: "Receta Medica generada, satisfactoriamente",
  Exam_Saved: "Examenes e Imagenes generada, satisfactoriamente",
  Inter_Saved: "Interconsulta generada, satisfactoriamente",
  Notes_Saved: "Notas guardadas satisfactoriamente",

  //Users
  Mail_Used:"El mail ya esta siendo utilizado por otro usuario",
  Phone_Used:"El telefono ya esta siendo utilizado por otro usuario", 
  Document_Used:"El documento ya esta siendo utilizado por otro usuario", 
  User_Created:"Usuario creado, correctamente", 
  User_Updated:"Usuario actualizado, correctamente", 
  UserAdmin_NotFound: "No se encontro usuario admin creado, para esta empresa",

  //Company
  Company_Saved:"Empresa creada correctamente",
  Company_Updated:"Empresa creada correctamente",
  NameCompany_exist:"Nombre de la empresa, ya existe",
  RucCompany_exist:"Ruc de la empresa, ya existe",
  DisAffiliationCompany:"Personal desafiliado correctamente",
  FreezeAccount:"Cuenta congelada, correctamente",
  DefrostAccount:"Cuenta descongelada, correctamente",
  SendInvitationToDoctorAffiliation:"Se envio la invitacion al doctor",
  SendInvitationToPersonnel:"Se envió la invitacion al usuario",
  NameExists:"El nombre del local ya existe",
  LocalCreated:"Local creado, correctamente",
  LocalUpdated:"Local actualizado, correctamente",
  LocalDeleted:"Local borrado, correctamente",
  Not_Exist_Local:"Local no encontrado",
  LinksCreated: "Empresas enlazadas correctamente",

  //Invitations
  Invitation_Created: "La invitacion fue creada correctamente",
  Mail_Used_Inv:"Ya se ha creado una invitacion con ese Email", 
  Document_Used_Inv:"Ya se ha creado una invitacion con ese documento", 
  Invitation_Delete: "Invitacion(es) borrado(s), correctamente",
  Invitation_Created_LoadExcel: "Invitaciones creadas correctamente",
  Existent_User_Incorrect_Data: "Este usuario ya existe con otros datos",

  //Pharmacy
  Sku_Update_Success: "El SKU fue modificado correctamente",
  Sku_Update_Error: "Hubo un error al modificar el SKU",
  Sku_Delete_Success: "El SKU fue eliminado correctamente",
  Sku_Delete_Error: "Hubo un problema al borrar el SKU",
  PharmacyRx_Delete_Success: "La receta fue eliminada correctamente",
  PharmacyRx_Delete_Error: "Hubo un problema al borrar la receta",
  MedicSupplyRx_Delete_Success: "El paquete fue eliminado correctamente",
  MedicSupplyRx_Delete_Error: "Hubo un problema al borrar el paquete",
};

export const messagelanguage = { 
  message: messagesSpanish,
};
